import _implicitStylesheets from "./validationStatusCellItem.css";

import _implicitScopedStylesheets from "./validationStatusCellItem.scoped.css?scoped=true";

import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, d: api_dynamic_text, t: api_text, h: api_element} = $api;
  const {_m0, _m1} = $ctx;
  return [$cmp.isError ? api_element("div", {
    classMap: {
      "validation-cell-text_truncate": true
    },
    key: 0
  }, [api_element("span", {
    key: 1,
    on: {
      "mouseover": _m0 || ($ctx._m0 = api_bind($cmp.handleMouseOver)),
      "mouseout": _m1 || ($ctx._m1 = api_bind($cmp.handleMouseOut))
    }
  }, [api_text(api_dynamic_text($cmp.message))]), api_element("div", {
    classMap: {
      "validation-data-cell-item_tooltip": true,
      "slds-popover": true,
      "slds-popover_tooltip": true,
      "slds-nubbin_bottom-left": true,
      "slds-fall-into-ground": true
    },
    attrs: {
      "role": "tooltip"
    },
    key: 2
  }, [api_element("div", {
    classMap: {
      "slds-popover__body": true,
      "slds-p-vertical_medium": true
    },
    key: 3
  }, [api_element("p", {
    key: 4
  }, [api_text(api_dynamic_text($cmp.validationTooltipMessages))])])])]) : null, !$cmp.isError ? api_element("div", {
    key: 5
  }, [api_element("img", {
    classMap: {
      "img-pos_align": true
    },
    attrs: {
      "src": "/resources/Checkmark-Success.svg"
    },
    key: 6
  }, [])]) : null, api_element("div", {
    key: 7
  }, [])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "my-validationStatusCellItem_validationStatusCellItem"
